import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
// import pinia from './store/counter';
import { createPinia } from 'pinia';
import Axios from 'axios';
import c from './utils/constant';
import { fetch, post, patch, put } from './utils/http';
import './styles/global.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { useAuthStore } from '@/store/auth';

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App);
const pinia = createPinia();

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 请求拦截器：自动加上 Token
Axios.interceptors.request.use(
    (config) => {
        const authStore = useAuthStore();
        console.log("authStore.token: " + authStore.token);
        if (authStore.token) {
            config.headers.Authorization = `Bearer ${authStore.token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器：处理 401 未授权
Axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const authStore = useAuthStore();
            authStore.logout();
            router.push('/login');
        }
        return Promise.reject(error);
    }
);


app.config.globalProperties.$http = Axios;
app.config.globalProperties.$fetch = fetch;
app.config.globalProperties.$post = post;
app.config.globalProperties.$patch = patch;
app.config.globalProperties.$put = put;
app.config.globalProperties.$c = c;

app.use(ElementPlus);
app.use(pinia); // 使用 Pinia
app.use(router); // 使用路由（如果需要）
app.mount('#app');